import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { signInWithEmailAndPassword, AuthErrorCodes } from "firebase/auth";
import { Button, Header, Input } from "../../../components";
import authStyles from "../Auth.module.css";
import { auth } from "../../../firebase";
import { LogoMedium, Multitask } from "../../../components/Images/Images";
import { UserContext } from "../../../contexts/userContext";
import { Spinner } from "../../../components/Icons/Icons";
import { authErrorMessages } from "../utils";

function Login(props) {
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams();

  const {user, setUserLoading} = useContext(UserContext);

  const [formValues, setFormValues] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();

  useEffect(() => {
    if(user && !props.modal){
      navigate('/')
    }
  }, [user])

  const handleChange = (e) => {
    let formValuesTemp = { ...formValues };
    formValuesTemp[e.target.name] = e.target.value;
    setFormValues(formValuesTemp);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setUserLoading(true)
    setError();
    signInWithEmailAndPassword(auth, formValues?.email, formValues?.password)
      .then((userCredential) => {
        // Signed in
        setLoading(false);
        // const user = userCredential.user;
        if(!props.modal){
          navigate('/')
        }
        // ...
      })
      .catch((error) => {
        setLoading(false);
        const errorCode = error.code;
        console.log(errorCode);
        setError(errorCode);
      });
  };

  const handleRegister = () => {
    setSearchParams({ ...searchParams, auth: "register" });
  };

  return (
    <div className={authStyles.authWrapper}>
      <div className={authStyles.container}>
        <div className={authStyles.innerContainer}>
          <Header
            className={authStyles.heading}
            content={
              <>
                Login{" "}
                <span style={{ fontSize: 16, float: "right", marginTop: 2 }}>
                  Or{" "}
                  {props.modal ? (
                    <Button
                      onClick={handleRegister}
                      type="link"
                      content="Create New Account"
                    />
                  ) : (
                    <Link
                      to="/register"
                      className={authStyles.link}
                      type="link"
                    >
                      Create New Account
                    </Link>
                  )}
                </span>
              </>
            }
            subheading="Access all your resumes"
          />
          <form onSubmit={handleSubmit}>
            <div className={authStyles.margin}>
              <Input
                label="Email"
                type="email"
                name="email"
                onChange={handleChange}
              />
            </div>
            <div className={authStyles.margin}>
              <Input
                label="Password"
                type="password"
                name="password"
                onChange={handleChange}
              />
            </div>
            <div className={authStyles.margin}>
              <Button
                content="Login"
                type="submit"
                loading={loading}
                disabled={!(formValues.email && formValues.password)}
              />
            </div>
          </form>
          <p className={authStyles.errorMessage}>{authErrorMessages[error]}</p>
          <Link
            style={{ fontWeight: 500, fontSize: 14, float: "right" }}
            className={authStyles.link}
            to="/forgot-password"
          >
            Forgot your password?
          </Link>
        </div>
        <div className={authStyles.imageWrapper}>
          <img src={LogoMedium} className={authStyles.logo} />
          <img className="image" src={Multitask} />
        </div>
      </div>
    </div>
  );
}

export default Login;
